import { HStack } from '@/components/Atoms'
import { DetailItem } from '@/components/DetailItem'
import { AuditTrail } from '@/hooks/queries/useAuditTrails'
import { useLocalizedDate } from '@/hooks/useLocalizedDate'
import { getUserFullname } from '@repo/utils'
import { useTranslation } from 'react-i18next'
import { useEventDetails } from './utils'

type AuditTrailDetailsHeaderProps = {
  auditTrail: AuditTrail
}

export function AuditTrailDetailsHeader(props: AuditTrailDetailsHeaderProps) {
  const { t } = useTranslation('admin')
  const { formatDateWithTime } = useLocalizedDate()

  const eventDetails = useEventDetails(props.auditTrail)

  return (
    <HStack gap="3xl">
      <DetailItem label={t('auditDetailsSheetHeader.createdBy')}>
        {props.auditTrail.createdBy.split('@')[0]}
      </DetailItem>
      <DetailItem label={t('auditDetailsSheetHeader.fullName')}>
        {props.auditTrail.user && getUserFullname(props.auditTrail.user)}
      </DetailItem>
      <DetailItem label={t('auditDetailsSheetHeader.createdAt')}>
        {formatDateWithTime(new Date(props.auditTrail.createdAt))}
      </DetailItem>
      {eventDetails.map((detail) => (
        <DetailItem key={detail.label} label={detail.label}>
          {detail.children}
        </DetailItem>
      ))}
    </HStack>
  )
}
